import { MAX_STRIPES } from "../game/stripes";
import "./Stripes.css";

interface Props {
  count: number;
  className?: string;
}

/** Three notches, filled for each stripe earned on the way to the next rank. */
export function Stripes({ count, className }: Props) {
  const n = Math.max(0, Math.min(MAX_STRIPES, count));
  return (
    <span
      className={["stripes", className].filter(Boolean).join(" ")}
      role="img"
      aria-label={`${n} of ${MAX_STRIPES} stripes`}
    >
      {Array.from({ length: MAX_STRIPES }, (_, i) => (
        <i key={i} className={i < n ? "on" : undefined} />
      ))}
    </span>
  );
}
